import {
  AlternateEmailOutlined,
  CreateOutlined,
  LockOutlined,
} from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import {
  currentUserBelongsToSupportGroupSelector,
  currentUserIsAdminSelector,
  currentUserIsReadOnlySelector,
} from "../../../../reducers/selectors";
import IntlMessages from "../../../../util/IntlMessages";

const useStyles = makeStyles({
  container: {
    display: "flex",
    position: "absolute",
    bottom: 0,
    backgroundColor: "white",
    width: "100%",
    padding: "30px",
  },
  button: {
    padding: "12px 24px",
    textTransform: "none",
    "&:not(:first-child)": {
      marginLeft: "10px",
    },
  },
});

const ProfileActions = ({ edit, editEmail, recoverSecurityCode }) => {
  const classes = useStyles();
  const userIsReadOnly = useSelector(currentUserIsReadOnlySelector);
  const belongsToSupportGroup = useSelector(
    currentUserBelongsToSupportGroupSelector
  );
  const isAdmin = useSelector(currentUserIsAdminSelector);
  const canEditEmail = belongsToSupportGroup || isAdmin;

  const actions = [
    {
      name: "edit",
      label: "pages.beneficiaryDetail.editUserInfo",
      icon: <CreateOutlined />,
      onClick: edit,
    },
    ...(canEditEmail
      ? [
          {
            name: "editEmail",
            label: "pages.beneficiaryDetail.editEmail",
            icon: <AlternateEmailOutlined />,
            onClick: editEmail,
          },
        ]
      : []),
    {
      name: "resetPinCode",
      label: "pages.beneficiaryDetail.resetPinCode",
      icon: <LockOutlined />,
      onClick: recoverSecurityCode,
    },
  ];

  return (
    <Box className={classes.container}>
      {actions.map((action) => (
        <Button
          key={action.name}
          id={action.name}
          variant="outlined"
          color="primary"
          endIcon={action.icon}
          onClick={() => action.onClick()}
          className={classes.button}
          disabled={userIsReadOnly}
          fullWidth
          disableElevation
          disableRipple
        >
          <IntlMessages id={action.label} />
        </Button>
      ))}
    </Box>
  );
};

export { ProfileActions };
